export class BackupJobTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<BackupJobType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<BackupJobType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupJobTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
